'use client';

import { customerNotificationsQueryKeyRoot } from '@/entities/customer-notification/api/customer-notifications/constants';
import { markCustomerNotificationsRead } from '@/entities/customer-notification/api/customer-notifications/server-actions';
import { getQueryClient } from '@/shared/api/query-client';
import {
    clearPendingSyncReadIds,
    getPendingSyncReadIds,
    setNewsReadSyncQueueEnabled,
} from './news-read-storage';

/** Push guest session reads to the account, then stop filling the sync queue until logout. */
export const syncGuestNewsReadAfterLogin = async (): Promise<void> => {
    const ids = [...getPendingSyncReadIds()];
    if (ids.length === 0) {
        setNewsReadSyncQueueEnabled(false);
        return;
    }

    const ok = await markCustomerNotificationsRead(ids);
    if (!ok) return;

    clearPendingSyncReadIds();
    setNewsReadSyncQueueEnabled(false);
    await getQueryClient().invalidateQueries({ queryKey: [...customerNotificationsQueryKeyRoot] });
};
